export const CREATE_PROSPECT_REQUEST = 'CREATE_PROSPECT_REQUEST';
export const CREATE_PROSPECT_SUCCESS = 'CREATE_PROSPECT_SUCCESS';
export const CREATE_PROSPECT_FAILURE = 'CREATE_PROSPECT_FAILURE';

export const GET_PROSPECTS_REQUEST = 'GET_PROSPECTS_REQUEST';
export const GET_PROSPECTS_SUCCESS = 'GET_PROSPECTS_SUCCESS';
export const GET_PROSPECTS_FAILURE = 'GET_PROSPECTS_FAILURE';

export const CLEAR_PROSPECT_ERROR = 'CLEAR_PROSPECT_ERROR';